import { AUTH_PURPOSE_KEY, PERFIL_KEY, TOKEN_KEY } from './constants'
import type { AuthPurpose, Candidato } from './types'

export function loadSession(): { token: string; candidato: Candidato | null } {
  try {
    const token = sessionStorage.getItem(TOKEN_KEY) || ''
    const raw = sessionStorage.getItem(PERFIL_KEY)
    const candidato = raw ? (JSON.parse(raw) as Candidato) : null
    return { token, candidato }
  } catch {
    return { token: '', candidato: null }
  }
}

export function persistSession(token: string, candidato: Candidato | null) {
  if (token) sessionStorage.setItem(TOKEN_KEY, token)
  else sessionStorage.removeItem(TOKEN_KEY)
  if (candidato) sessionStorage.setItem(PERFIL_KEY, JSON.stringify(candidato))
  else sessionStorage.removeItem(PERFIL_KEY)
}

export function setAuthPurposeStorage(purpose: AuthPurpose) {
  try {
    if (purpose === 'minhas') sessionStorage.setItem(AUTH_PURPOSE_KEY, 'minhas')
    else sessionStorage.removeItem(AUTH_PURPOSE_KEY)
  } catch {
    /* ignore */
  }
}

export function consumeAuthPurposeStorage(current: AuthPurpose): AuthPurpose {
  let purpose = current
  try {
    const stored = sessionStorage.getItem(AUTH_PURPOSE_KEY)
    if (stored === 'minhas') purpose = 'minhas'
    sessionStorage.removeItem(AUTH_PURPOSE_KEY)
  } catch {
    /* ignore */
  }
  return purpose === 'minhas' ? 'minhas' : 'candidatura'
}
